import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import store from '@/store/store'
import Login from '@/components/login/Login'

import Ledger from '@/components/ledger/List'
import Password from '@/components/password/Edit'

Vue.use(VueRouter);

export let router = new Router({
    routes: [{
            path: '/',
            name: 'empty-path',
            component: Ledger,
            meta: {
                auth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                auth: false
            }
        },
        {
            path: '/ledger',
            name: 'ledger-list',
            component: Ledger,
            meta: {
                auth: true
            }
        },
        {
            path: '/password',
            name: 'password-change',
            component: Password,
            meta: {
                auth: true
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    let level = -1;
    if (store.state.user) {
        level = store.state.user.level;
    }
    if (to.meta.auth && (!store.state.isUserLoggedIn || level !== 0)) {
        next({
            path: '/login',
            query: {
                redirect: to.fullPath
            }
        });
    } else {
        if (to.meta.auth && store.state.logTime == null) {
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            });
        } else {
            if (to.meta.auth && (Date.now() - store.state.logTime >= 43200000)) {
                next({
                    path: '/login',
                    query: {
                        redirect: to.fullPath
                    }
                });
            } else {
                if (store.state.isUserLoggedIn && !store.state.user.hasChangedPassword && to.path !== '/password') {
                    next({
                        path: '/password',
                        query: {
                            redirect: to.fullPath
                        }
                    });
                } else {
                    next();
                }
            }
        }
    }
})

export default router